import { CommonModule } from "@angular/common";
import {
    booleanAttribute,
    Component,
    ElementRef,
    input,
    viewChild,
} from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { BaseConfig } from "../../common/config/config.adapter";

@Component({
    selector: "[modalContainer]",
    template: `
        <section #modal class="bg-white modal-container slide">
            <section
                [class.safe-top]="platform !== 'web'"
                class="rounded-t-none md:rounded-t-[20px] overflow-hidden min-h-max w-full"
            >
                <ng-content select="[header]" />
            </section>
            <section
                class="modal-content"
                [class.overflow-y-auto]="scrollEnabled()"
            >
                <ng-content />
                @if (!invisibleWhitespace()) {
                    <div class="h-[10rem] md:hidden"></div>
                }
            </section>
            <section
                [class.safe-bottom]="platform !== 'web'"
                class="md:static fixed bottom-0 w-full xl:rounded-b-[20px] overflow-hidden bg-white"
            >
                <ng-content select="[footer]" />
            </section>
        </section>
    `,
    imports: [CommonModule],
    styleUrls: ["./modal-container.component.scss"],
})
export class ModalContainer extends BaseConfig {
    scrollEnabled = input<boolean, string>(false, {
        transform: booleanAttribute,
    });
    modalRef = viewChild<ElementRef<HTMLElement>>("modal");
    invisibleWhitespace = input<boolean, string>(false, {
        transform: booleanAttribute,
    });
    platform = Capacitor.getPlatform();

    ngAfterViewInit() {
        this.modalRef()?.nativeElement.animate(
            [
                { opacity: 0, transform: "translateY(10px)" },
                { opacity: 1, transform: "translateY(0)" },
            ],
            {
                duration: 200,
                easing: "ease-in-out",
            },
        );
    }
}
